<template>
  <CstuModal
    id="custom-generate-modal"
    title="Review & Generate"
    content-class="w-[650px]"
    dialog-class="!max-w-[650px]"
    body-class="no-scrollbar"
    scrollable
    size="lg"
    hide-footer
    centered
    radius="xl"
    no-close-on-backdrop
    @hidden="handleClose"
  >
    <!-- Modal Body -->
      <CustomGenerateForm
        :modal="true"
      />
  </CstuModal>
</template>

<script setup>
import { inject } from 'vue'
import CustomGenerateForm from '@src/modules/publisher/ai-content-library/components/form/CustomGenerateForm.vue'
import { useSetup } from '@modules/publisher/ai-content-library/composables/useSetup'
import { useAIPostGeneration } from '@modules/publisher/ai-content-library/composables/useAIPostGeneration'

const root = inject('root')
const { $cstuModal } = root

const { AIUserProfile } = useSetup()
const { resetCustomPostGeneration } = useAIPostGeneration(AIUserProfile)


const handleClose = () => {
  $cstuModal.hide('custom-generate-modal')

  resetCustomPostGeneration()
}

</script>
